import { createFileRoute } from '@tanstack/react-router';
import { LookupSelects } from '@/demo/lookup-select.tsx';

export const Route = createFileRoute('/_auth/demo/lookup/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <LookupSelects />;
}
